export default "__VITE_PUBLIC_ASSET__95bf46f8__"